import { render, staticRenderFns } from "./DrugManagement.vue?vue&type=template&id=250614b4&scoped=true"
import script from "./DrugManagement.vue?vue&type=script&lang=js"
export * from "./DrugManagement.vue?vue&type=script&lang=js"
import style0 from "./DrugManagement.vue?vue&type=style&index=0&id=250614b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250614b4",
  null
  
)

export default component.exports